
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';

import { logout, mudarProcesso, changeState, mudarMensagens, mergeProvasRespostas } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import { formatDuration, ServerClock } from './serverClock';
import SweetAlert from 'react-bootstrap-sweetalert';
import { decrypt, URL } from '../variables';
import Prova from './Prova';
import Redacao from './Redacao';
import Chat from './Chat';
import Questionario from './Questionario';
import { validate as isUuid } from 'uuid';

// import { DiffCamEngine, stopStreaming } from './DetectMovement';
import RequestUser from './RequestUser';
import RequestAccepted from './RequestAccepted';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import { CandidateLoader, CandidateValidationNotice } from './CandidateUi';

// import lz from 'lz-string';

class AvaliacaoAndamento extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            show_warning: false,
            loading_finish: false,
            tab: 0,
            title_warning: '',
            show_warning_page: false,
            last_warning: moment(),
            loading_pause: false,
            show_pause_modal: false,
            show_pause_modal_accepted: false,

            message_warning: getLanguageTexts(getSelectedLanguage()).evaluation_page_exit_registered,
            show_pause_timer: false,
            goTo: null,
            selectedLanguage: getSelectedLanguage()
        };
        this.videoRef = React.createRef();
        this.selects_questions = {};


        this.last_date = moment().format('YYYY-MM-DD HH:mm:ss');
        this.last_date_request = moment().format('YYYY-MM-DD HH:mm:ss');


        this.time_text = '88:88:88';
        this.time_text_pause = '88:88:88';


        this.respostas = {}
        this.respostas_dissertativa = {};
        this.timer_pause_init = 20;
        this.serverClock = new ServerClock();
        this.umount = true;
        this.id = '';
        this.handleLanguageEvent = this.handleLanguageEvent.bind(this);
    }

    handleLanguageEvent(event) {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }



    componentDidUpdate(prevProps) {
        // console.log('new');
        // console.log(prevProps.stream);
        // console.log(this.props.stream);

        if (this.props.stream != null && this.props.stream.id != prevProps.stream.id) {
            this.videoRef.current.srcObject = this.props.stream;
        }
        if (this.props.tempo_atual != null && this.props.tempo_atual != prevProps.tempo_atual) {
            this.serverClock.sync(this.props.tempo_atual);
        }


        if (this.fim != this.props.processo.fim) {
            this.fim = this.props.processo.fim;
        }

        if (prevProps.socket == null && this.props.socket != null) {
            try {

                this.props.socket.on("request_pause", (data) => {
                    console.log('request pause', data);
                    if (data.type == 'request') {
                        this.props.changeState({ request_user: data });
                    }
                    else if (data.type == 'response') {
                        if (data.approved == false) {
                            this.props.changeState({ request_user: data });

                            const t = getLanguageTexts(this.state.selectedLanguage);
                            this.setState({ show_warning_page: true, loading_pause: false, message_warning: t.pause_request_denied });
                        }
                        else if (data.approved == true && this.props.request_user.pause_end == null) {
                            if (data.updated_at != this.props.request_user.updated_at) {
                                this.setState({ show_pause_modal_accepted: true, loading_pause: false, request_user: data });
                            }
                            else {
                                console.log('nao é igual')
                                console.log({ ...this.props.request_user })
                                this.setState({ loading_pause: false })
                            }
                            this.props.changeState({ request_user: data });

                            // if(data.started==null){
                            //     this.timerPause();
                            // }
                        }
                    }
                    clearTimeout(this.waitResponsePause);
                });

                this.props.socket.on('timers_oral_exam', function (data) {
                    console.log('timers', data)
                    let user_ = { ...this.props.user };
                    user_.timers = data.timers;
                    this.props.changeState({ user: user_ });
                    // this.setState({connect:false});
                }.bind(this));

                this.props.socket.on("finish_event", (data) => {
                    console.log('finish_event', data);
                    if (this.props.processo.is_interview && data.processo_id == this.props.processo.id) {

                        this.props.get_processo();
                    }
                });

                if (this.props.user.accessibility && this.props.user.type_supervisor != 'none' && this.props.processo.is_interview == false) {
                    console.log('montou', this.props.user)
                    this.props.changeState({ show_call: true });
                }
            }
            catch (e) {

            }
        }


        // if (prevProps.processo.movement != this.props.processo.movement && this.props.processo.movement == true && this.props.processo.type_fiscalization != 'none') {
        //     try {
        //         if (DiffCamEngine.getInit() == false) {
        //             console.log('iniciando');
        //             // DiffCamEngine.init({
        //             //     video: document.getElementById('video_oficial'),
        //             //     movementCallBack: (score) => this.movementDetect(score),
        //             //     scoreThreshold: 400
        //             //     // motionCanvas: document.getElementById('motion'),
        //             // });
        //         }


        //     }
        //     catch (e) {
        //         console.log(e);
        //     }
        // }
        // else if (prevProps.processo.movement != this.props.processo.movement && this.props.processo.movement == false) {
        //     try {
        //         stopStreaming();


        //     }
        //     catch (e) {
        //         console.log(e);
        //     }
        // }


    }

    incTimer() {
        if (!this.serverClock.isReady()) {
            this.timer_timeout = setTimeout(() => this.incTimer(), 1000);
            return;
        }
        let totalSecs = this.serverClock.secondsUntil(this.fim);
        const formattedTime = formatDuration(totalSecs);
        if (document.getElementById('timer') == null) {
            return;
        }
        if (totalSecs <= 0) {
            totalSecs = 0;
            this.time_text = "00:00:00";
            const t = getLanguageTexts(this.state.selectedLanguage);
            document.getElementById('timer').innerHTML = t.remaining_time + ': 00:00:00';
            this.isFinish = true;

            this.props.get_processo();
        }
        else {
            this.time_text = formattedTime;
            const t = getLanguageTexts(this.state.selectedLanguage);
            document.getElementById('timer').innerHTML = t.remaining_time + ': ' + formattedTime;
            // console.log('Tempo restante: '+currentHours + ":" + currentMinutes + ":" + currentSeconds);
            // console.log(this.time_text);

            this.timer_timeout = setTimeout(function () {
                this.incTimer()
            }.bind(this), 1000);
        }
    }

    incTimerRequest() {
        console.log('request', { ...this.props.request_user })
        if (this.props.request_user == null || this.props.request_user.started == null) {
            return;
        }
        if (!this.serverClock.isReady()) {
            this.timer_timeout_request = setTimeout(() => this.incTimerRequest(), 1000);
            return;
        }
        const pauseEnd = moment(this.props.request_user.started, 'YYYY-MM-DD HH:mm:ss')
            .add(this.props.request_user.time, 'seconds');
        var totalSecs = this.serverClock.secondsUntil(pauseEnd);
        var currentHours = Math.floor((totalSecs / 60) / 60);
        var currentMinutes = Math.floor(totalSecs / 60) - currentHours * 60
        console.log(totalSecs)
        var currentSeconds = totalSecs % 60;
        if (currentSeconds <= 9) currentSeconds = "0" + currentSeconds;
        if (currentMinutes <= 9) currentMinutes = "0" + currentMinutes;
        if (currentHours <= 9) currentHours = "0" + currentHours;
        if (document.getElementById('timer_request') == null) {
            return;
        }
        if (totalSecs <= 0) {
            totalSecs = 0;
            this.time_text_pause = "00:00:00";
            const t = getLanguageTexts(this.state.selectedLanguage);
            document.getElementById('timer_request').innerHTML = t.pause_remaining_time + ': 00:00';

            // this.props.get_processo();
            this.setState({ pause_end: true });
        }
        else {
            this.time_text_pause = + currentMinutes + ":" + currentSeconds;
            const t = getLanguageTexts(this.state.selectedLanguage);
            document.getElementById('timer_request').innerHTML = t.pause_remaining_time + ': ' + currentMinutes + ":" + currentSeconds;
            // console.log('Tempo restante: '+currentHours + ":" + currentMinutes + ":" + currentSeconds);
            // console.log(this.time_text);

            this.timer_timeout_request = setTimeout(function () {
                this.incTimerRequest();
            }.bind(this), 1000);
        }
    }

    send_status() {
        if (this.videoRef.current == null) {
            console.log('Status not send 1');

            return;
        }
        if (this.props.socket != null) {
            console.log('Status send');
            const statusPayload = {
                aluno_id: this.props.user.id,
                sala_id: this.props.sala.id,
                processo_id: this.props.processo.id,
                faculdade_id: this.props.faculdade.id,
                candidate_inside_screen: this.props.candidate_inside_screen == true
            };

            if (this.props.user.candidate_ip != null) {
                statusPayload.ip = this.props.user.candidate_ip;
            }

            this.props.socket.emit("send_status", statusPayload);
            setTimeout(() => {
                this.send_status();
            }, 60000);
        }
        else {
            console.log('Status not send 2');

        }
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    async salvar_log(event) {
        let event_m = '';
        if (event.type == 'blur') {
            this.props.changeState({ candidate_inside_screen: false });
            if (this.props.socket != null) {
                this.props.socket.emit("send_status", {
                    aluno_id: this.props.user.id,
                    sala_id: this.props.sala.id,
                    processo_id: this.props.processo.id,
                    faculdade_id: this.props.faculdade.id,
                    candidate_inside_screen: false
                });
            }
            if (moment().diff(this.state.last_warning, 'seconds') > 30 && this.props.processo.type_fiscalization == 'all' && this.props.processo.is_interview == false) {
                const t = getLanguageTexts(this.state.selectedLanguage);
                this.setState({ show_warning_page: true, last_warning: moment(), message_warning: t.evaluation_page_exit_registered });
            }
            event_m = 'desfocou';
            if (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') {
                if (this.props.socket != null) {

                    this.props.socket.emit("send_warning_behavior", { processo_id: this.props.processo.id, msg: 'O candidato saiu da página da avaliação', sala_id: this.props.sala.id, aluno_id: this.props.user.id, nome_chat: this.props.user.name, id_msg: this.uuidv4(), faculdade_id: this.props.faculdade.id, type: 'out', candidate_inside_screen: false });
                }
            }

        }
        else {
            this.props.changeState({ candidate_inside_screen: true });
            if (this.props.socket != null) {
                this.props.socket.emit("send_status", {
                    aluno_id: this.props.user.id,
                    sala_id: this.props.sala.id,
                    processo_id: this.props.processo.id,
                    faculdade_id: this.props.faculdade.id,
                    candidate_inside_screen: true
                });
            }
            event_m = 'focou';
            if (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') {
                if (this.props.socket != null) {

                    this.props.socket.emit("send_warning_behavior", { processo_id: this.props.processo.id, msg: 'O candidato voltou para a página da avaliação', sala_id: this.props.sala.id, aluno_id: this.props.user.id, nome_chat: this.props.user.name, id_msg: this.uuidv4(), faculdade_id: this.props.faculdade.id, type: 'in', candidate_inside_screen: true });
                }
            }
        }


        fetch(`${URL}api/salvar_log?v=a&screen=${event_m}&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (resp.status == false) {
                        this.props.get_processo();
                    }
                    else {
                        if (resp.processo != null && (resp.processo.chat_type != this.props.processo.chat_type || resp.processo.updated_at != this.props.processo.updated_at)) {
                            this.props.changeState({ processo: resp.processo });
                        }
                        if (resp.atual != undefined) {
                            this.serverClock.sync(resp.atual);
                            this.props.changeState({ tempo_atual: resp.atual });
                        }
                    }

                }
            } catch (err) {
                console.log(err);
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }


    async salvar_log_warning(event_warning, number_aba) {

        fetch(`${URL}api/salvar_log?v=a&screen=${event_warning}&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}&msg=${number_aba}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (resp.status == false) {
                        this.props.get_processo();
                    }
                    else {
                        if (resp.processo != null && (resp.processo.chat_type != this.props.processo.chat_type || resp.processo.updated_at != this.props.processo.updated_at)) {
                            this.props.changeState({ processo: resp.processo });
                        }
                    }

                }
            } catch (err) {
                console.log(err);
            }

        })
            .catch((err) => {
                console.log(err);
            });
    }

    componentDidMount() {

        console.log('montou')
        window.addEventListener('candidate_language_change', this.handleLanguageEvent);
        if (this.props.setEvaluationCaptureProvider) {
            this.props.setEvaluationCaptureProvider(() => this.getCaptureData());
        }
        this.isFinish = false;

        if (this.umount == true) {
            this.id = this.uuidv4();
            this.umount = false;
            this.props.changeState({ andamento: true });
            // if (this.props.processo.movement == true && this.props.processo.type_fiscalization != 'none') {
            //     try {
            //         if (DiffCamEngine.getInit() == false) {
            //             console.log('iniciando');
            //             // DiffCamEngine.init({
            //             //     video: document.getElementById('video_oficial'),
            //             //     movementCallBack: (score) => this.movementDetect(score),
            //             //     scoreThreshold: 400
            //             //     // motionCanvas: document.getElementById('motion'),
            //             // });
            //         }


            //     }
            //     catch (e) {
            //         console.log(e);
            //     }
            // }

            if (this.props.processo.simulado == false) {
                this.salvar_log_bind = this.salvar_log.bind(this);
                window.addEventListener('focus', this.salvar_log_bind);
                window.addEventListener('blur', this.salvar_log_bind);
            }
            else {
                this.lineCheckInterval = setInterval(() => {
                    if (this.props.socket != null) {
                        this.props.socket.emit("line_check", { aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id, enter_now: true });
                    }
                }, 30000);
            }

            if (this.props.request_user != null) {
                if (this.props.request_user.approved == null) {
                    this.setState({ loading_pause: true })
                }
                else if (this.props.request_user.approved == true && this.props.request_user.pause_end == null) {
                    if (this.props.request_user.started == null) {
                        this.setState({ show_pause_modal_accepted: true })
                    }
                    else {
                        this.setState({ show_pause_timer: true }, () => {
                            clearTimeout(this.timer_timeout_request)
                            this.last_date_request = moment().format('YYYY-MM-DD HH:mm:ss');

                            this.incTimerRequest();
                        });
                    }
                }

            }
            this.serverClock.sync(this.props.tempo_atual);

            this.fim = this.props.processo.fim;
            console.log('INICIOU TIMER');
            this.incTimer();
            if (this.props.processo.type_fiscalization == 'all') {

                this.videoRef.current.srcObject = this.props.stream;
                this.send_status();


            }
            else if (this.props.processo.type_fiscalization == 'image') {
                // this.timeout_save_logs_and_wording = setTimeout(() => {
                //     this.save_logs_and_wording();
                // }, 30000);
                this.timer_save = !this.props.processo.save_timer || this.props.processo.save_timer < 30000 ? 30000 : this.props.processo.save_timer;
                this.send_status();

                this.videoRef.current.srcObject = this.props.stream;
            }
            else {
                this.timer_save = !this.props.processo.save_timer || this.props.processo.save_timer < 30000 ? 30000 : this.props.processo.save_timer;
            }
            setTimeout(() => {
                this.get_time_server();
            }, 30000);

            if (this.props.socket != null) {
                console.log('entrouuuu')
                this.props.socket.on("request_pause", (data) => {
                    console.log('request pause', data);
                    if (data.type == 'request') {
                        this.props.changeState({ request_user: data });
                    }
                    else if (data.type == 'response') {
                        if (data.approved == false) {
                            this.props.changeState({ request_user: data });

                            const t = getLanguageTexts(this.state.selectedLanguage);
                            this.setState({ show_warning_page: true, loading_pause: false, message_warning: t.pause_request_denied });
                        }
                        else if (data.approved == true && this.props.request_user?.pause_end == null) {
                            if (data.updated_at != this.props.request_user?.updated_at) {
                                this.setState({ show_pause_modal_accepted: true, loading_pause: false, request_user: data });
                            }
                            else {
                                console.log('nao é igual')
                                console.log({ ...this.props.request_user })
                                this.setState({ loading_pause: false })
                            }
                            this.props.changeState({ request_user: data });

                            // if(data.started==null){
                            //     this.timerPause();
                            // }
                        }
                    }
                    clearTimeout(this.waitResponsePause);
                });
                this.props.socket.on('timers_oral_exam', function (data) {
                    console.log('timers', data)
                    let user_ = { ...this.props.user };
                    user_.timers = data.timers;
                    this.props.changeState({ user: user_ });
                    // this.setState({connect:false});
                }.bind(this));

                this.props.socket.on("finish_event", (data) => {
                    console.log('finish_event', data);
                    if (this.props.processo.is_interview && data.processo_id == this.props.processo.id) {

                        this.props.get_processo();
                    }
                });




                if (this.props.user.accessibility && this.props.user.type_supervisor != 'none' && this.props.processo.is_interview == false) {
                    console.log('montou', this.props.user)
                    this.props.changeState({ show_call: true });
                }

            }

            if (this.props.processo.exam_per_time == true) {
                let filtered = [...this.props.questionarios, ...this.props.provas, ...this.props.redacoes].map((item, id) => {
                    let return_value = false;
                    if (item.prova != undefined) {
                        let questoes_number = item.questoes.map((item, id) => {
                            if (item.type_questao == 'conjunto') {
                                return item.questoes.length;
                            }
                            else {
                                return 1;
                            }
                        }).reduce((a, b) => a + b, 0);

                        if (item.order != null && questoes_number < item.order.select_question) {
                            return_value = true
                        }


                    }
                    else {
                        if (item.resultado.finish == true) {
                            return_value = true;
                        }
                    }

                    return return_value;

                });
                console.log(filtered)
                let index_filter = filtered.indexOf(false);
                if (index_filter == -1) {
                    index_filter = filtered.length - 1;
                }
                console.log('tab', index_filter);
                this.setState({ tab: index_filter });
            }/////
        }

    }

    movementDetect(score) {
        console.log(score)
        this.props.socket.emit("send_warning_movement", { sala_id: this.props.sala.id, aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id });
        this.salvar_log_warning('movement', 'Movimento detectado. Score: ' + score);
    }

    persistDissertativeAnswers() {
        if (Object.keys(this.respostas_dissertativa).length == 0) {
            return;
        }
        this.props.mergeProvasRespostas(this.respostas_dissertativa);
    }

    componentWillUnmount() {
        this.persistDissertativeAnswers();
        if (this.props.setEvaluationCaptureProvider) {
            this.props.setEvaluationCaptureProvider(null);
        }
        console.log('desmontou')
        window.removeEventListener('candidate_language_change', this.handleLanguageEvent);
        // if(this.props.socket){
        //     this.props.socket.removeAllListeners('timers_oral_exam');
        //     this.props.socket.removeAllListeners('finish_event');
        //     this.props.socket.removeAllListeners('request_pause');
        // }
        if (this.isFinish != true) {
            this.save_logs_and_wording()
        }
        else {
            this.props.changeStateParent({ show_face_mesh: false });
        }
        //
        this.umount = true;
        this.props.changeState({ andamento: false, show_call: false });
        if (this.props.processo.simulado == false) {
            window.removeEventListener('focus', this.salvar_log_bind);
            window.removeEventListener('blur', this.salvar_log_bind);
        }
        clearTimeout(this.timer_timeout);
        clearTimeout(this.timer_timeout_request);

        clearTimeout(this.timeout_save_logs_and_wording);
        clearInterval(this.lineCheckInterval);
        clearInterval(this.timeout_pause);
        clearTimeout(this.timeout_pause_init)



    }


    get_time_server() {
        if (this.videoRef.current == null) {
            return;
        }
        fetch(`${URL}api/get_time_server?v=a`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                else {
                    if (resp.atual != null) {
                        this.serverClock.sync(resp.atual);

                        this.props.changeState({ tempo_atual: resp.atual });
                    }
                }
                setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            } catch (err) {
                console.log(err);
                setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            }

        })
            .catch((err) => {
                console.log(err);
                setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            });
    }

    getCaptureData() {
        return {
            time_text: this.time_text,
            tab: this.state.tab,
            respostas: this.respostas
        };
    }

    save_logs_and_wording() {
        let textos = [];
        let titulos = [];
        let redacao_ids = [];
        for (let i = 0; i < this.props.redacoes.length; i++) {
            textos.push(this.props.redacoes[i].resultado.texto);
            titulos.push(this.props.redacoes[i].resultado.titulo);
            redacao_ids.push(this.props.redacoes[i].redacao.id);
        }

        let form = new FormData();
        if (redacao_ids.length > 0) {
            for (let i = 0; i < redacao_ids.length; i++) {
                form.append('textos[]', textos[i]);
                form.append('titulos[]', titulos[i]);
                form.append('redacao_ids[]', redacao_ids[i]);
            }
        }
        form.append('processo_id', this.props.processo.id);
        if (Object.values(this.respostas).length > 0) {
            form.append('respostas', JSON.stringify(this.respostas))
        }

        fetch(`${URL}api/save_logs_and_wording?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            },
            body: form
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (resp.status == false || resp.message == 'Server Error') {
                        this.props.get_processo();
                    }
                    else if (resp.processo == null) {
                        this.props.changeState({ processo: null, stream: null, stream_screen: null });
                    }


                }




            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }


    pause_status(type = 'start') {

        fetch(type == 'start' ? `${URL}api/request_start?v=a` : `${URL}api/request_end?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: this.props.request_user?.id,
                processo_id: this.props.processo?.id,
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (resp.status == false || resp.message == 'Server Error') {
                        this.timeout_pause = setTimeout(() => {
                            this.pause_status(type);
                        }, 5000);
                    }
                    else if (resp.processo == null) {
                        this.props.changeState({ processo: null, stream: null, stream_screen: null });
                    }
                    else {
                        let data_request = {};
                        if (resp.request_user != null && resp.request_user.updated_at != this.props.request_user?.updated_at) {
                            data_request = {
                                request_user: resp.request_user
                            };
                        }
                        if (resp.processo != null && (resp.processo.chat_type != this.props.processo.chat_type || resp.processo.full_screen != this.props.processo.full_screen || this.props.processo.fim != resp.processo.fim || resp.processo.updated_at != this.props.processo.updated_at || data_request.request_user != undefined)) {
                            this.props.changeState({ processo: resp.processo, ...data_request });
                            this.fim = resp.processo.fim;
                        }
                        if (type == 'start') {
                            console.log('iniciou timer')
                            let provas = [...this.props.provas];
                            provas = provas.map((item) => {
                                resp.blockeds.map((b) => {
                                    if (b.prova_id == item.prova.id) {
                                        item.blockeds = b;
                                    }
                                })
                                return item;
                            })
                            this.setState({ loading_pause_response: false, show_pause_timer: true }, () => {
                                clearTimeout(this.timer_timeout_request)
                                this.last_date_request = moment().format('YYYY-MM-DD HH:mm:ss');

                                this.incTimerRequest();
                            });
                        }
                        else {
                            this.setState({ loading_pause_response: false, show_pause_timer: false, loading_pause: false })
                        }



                    }


                }




            } catch (err) {
                console.log(err);
                this.timeout_pause = setTimeout(() => {
                    this.pause_status(type);
                }, 5000);

            }

        })
            .catch((err) => {

                console.log(err);
                this.timeout_pause = setTimeout(() => {
                    this.pause_status(type);
                }, 5000);
                // this.props.mudarLoadingHome(false);
            });
    }



    async finalizar_avaliacao() {

        let textos = [];
        let titulos = [];
        let redacao_ids = [];
        for (let i = 0; i < this.props.redacoes.length; i++) {
            textos.push(this.props.redacoes[i].resultado.texto);
            titulos.push(this.props.redacoes[i].resultado.titulo);
            redacao_ids.push(this.props.redacoes[i].redacao.id);
        }

        let respostas_questionarios = [];
        for (let i = 0; i < this.props.questionarios.length; i++) {
            respostas_questionarios.push({ respostas: this.props.questionarios[i].respostas, questionario_id: this.props.questionarios[i].questionario.id });
        }

        let data = {}
        if (Object.values(this.respostas).length > 0) {
            data = { respostas: JSON.stringify(this.respostas) }
        }

        fetch(`${URL}api/finalizar_avaliacao?v=a`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                titulo: titulos,
                redacao_id: redacao_ids,
                texto: textos,
                processo_id: this.props.processo.id,
                respostas_questionarios,
                ...data
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (this.props.socket != null) {
                        this.props.socket.emit("finish_event", { sala_id: this.props.sala.id, aluno_id: this.props.user.id, finish: true, faculdade_id: this.props.faculdade.id });
                    }
                    this.isFinish = true;
                    this.setState({ loading_finish: false });
                    this.props.aceitar_regras(resp);
                }
            } catch (err) {
                this.setState({ loading_finish: false });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ loading_finish: false });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }

    changeTab(k) {
        console.log(k)
        this.setState({ tab: k })
        this.salvar_log_warning('alter_tab', 'Aba: ' + k.toString())
    }

    renderWorkbookTitle(label, type) {
        const icons = {
            questionario: 'mdi-format-list-checks',
            objetiva: 'mdi-checkbox-marked-circle-outline',
            dissertativa: 'mdi-textbox',
            redacao: 'mdi-file-document-box-outline',
            entrevista: 'mdi-voice'
        };

        return (
            <span className="candidate-workbook-tab-title">
                <i className={`mdi ${icons[type] || icons.objetiva}`}></i>
                <span>{label}</span>
            </span>
        );
    }




    finishExam() {
        if (this.props.processo.exam_per_time == false) {
            let achou = false;
            let achou_redacao = false;
            let achou_questionario = false;
            let achou_dissertativa = false;
            try {

                for (let i = 0; i < this.props.provas.length; i++) {
                    for (let j = 0; j < this.props.provas[i].questoes.length; j++) {
                        if (this.respostas_dissertativa[this.props.provas[i].prova.id] == undefined) {
                            this.respostas_dissertativa[this.props.provas[i].prova.id] = {}
                        }
                        let respostas = { ...this.props.provas[i].respostas, ...this.respostas_dissertativa[this.props.provas[i].prova.id] }

                        if (this.props.provas[i].respostas[this.props.provas[i].questoes[j].id] == undefined && this.props.provas[i].questoes[j].type_questao == 'simples') {
                            achou = true;
                            break;
                        }
                        else if (this.props.provas[i].questoes[j].type_questao == 'dissertativa' && ((respostas[this.props.provas[i].questoes[j].id] == undefined || respostas[this.props.provas[i].questoes[j].id].trim().length == 0)
                        )) {
                            achou_dissertativa = true;
                            break;
                        }
                        else if (this.props.provas[i].questoes[j].type_questao == 'conjunto') {
                            this.props.provas[i].questoes[j].questoes.map((item3, id3) => {
                                if (this.props.provas[i].respostas[item3.id] == undefined) {
                                    achou = true;
                                }
                            })
                        }
                    }
                    if (achou == true) {
                        break;
                    }
                }
                for (let k = 0; k < this.props.questionarios.length; k++) {

                    for (let i = 0; i < Object.keys(this.props.questionarios[k].respostas).length; i++) {
                        let resposta = this.props.questionarios[k].respostas[Object.keys(this.props.questionarios[k].respostas)[i]];
                        // console.log(resposta);
                        if (resposta['type'] == 'multipla_escolha' && resposta['alternativa_id'] == null) {
                            // this.setState({ loading_save: false, msg_erro: 'Você não respondeu todas as questões', show_error: true });
                            // return;
                            achou_questionario = true;
                        }
                        if (resposta['type'] == 'paragrafo') {
                            let texto = Object.values(resposta['textos'])[0]['texto'];
                            if ((texto == null || texto.trim().length == 0) && (Object.values(resposta['checkboxs']).length == 0 || Object.values(resposta['checkboxs'])[0] == false)) {
                                // this.setState({ loading_save: false, msg_erro: 'Você não respondeu todas as questões', show_error: true });
                                // return;
                                achou_questionario = true;
                            }
                        }
                        if (resposta['type'] == 'multipla_escolha') {
                            for (let j = 0; j < Object.values(resposta['textos']).length; j++) {
                                let texto = resposta['textos'][Object.keys(resposta['textos'])[j]];
                                if ((texto['texto'] == null || texto['texto'].trim().length == 0) && ((texto['required'] == 'required') || (isUuid(texto['required']) && texto['required'] == resposta['alternativa_id']))) {
                                    // this.setState({ loading_save: false, msg_erro: 'Você não respondeu todas as questões', show_error: true });
                                    // return;
                                    achou_questionario = true;
                                }
                            }
                        }
                    }
                }


                for (let i = 0; i < this.props.redacoes.length; i++) {
                    let redacao = this.props.redacoes[i];
                    if (redacao.resultado.texto == null || redacao.resultado.texto.trim().length == 0) {
                        achou_redacao = true;
                        break
                    }
                }
            } catch (e) {
                console.log(e)
            }

            console.log(achou_dissertativa)
            if (achou_dissertativa == true) {
                const t = getLanguageTexts(this.state.selectedLanguage);
                this.setState({ show_warning: true, title_warning: t.finish_unanswered_workbooks_confirm })
            }
            else if (achou == true) {
                const t = getLanguageTexts(this.state.selectedLanguage);
                this.setState({ show_warning: true, title_warning: t.finish_unanswered_workbooks_confirm })
            }

            else if (achou_redacao == true) {
                const t = getLanguageTexts(this.state.selectedLanguage);
                this.setState({ show_warning: true, title_warning: t.finish_unanswered_workbooks_confirm })

            }
            else if (achou_questionario == true) {
                const t = getLanguageTexts(this.state.selectedLanguage);
                this.setState({ show_warning: true, title_warning: t.finish_unanswered_workbooks_confirm })

            }
            else {
                const t = getLanguageTexts(this.state.selectedLanguage);
                this.setState({ show_warning: true, title_warning: t.finish_evaluation_confirm })
            }
        }
        else {
            console.log(this.selects_questions);
            let filtered = [...this.props.questionarios, ...this.props.provas, ...this.props.redacoes].map((item, id) => {
                let return_value = false;
                if (item.prova != undefined) {
                    let questoes_number = item.questoes.map((item, id) => {
                        if (item.type_questao == 'conjunto') {
                            return item.questoes.length;
                        }
                        else {
                            return 1;
                        }
                    }).reduce((a, b) => a + b, 0);

                    if (item.order != null && questoes_number < this.selects_questions[item.prova.id]) {
                        return_value = true
                    }


                }
                else {
                    if (item.resultado.finish == true) {
                        return_value = true;
                    }
                }

                return return_value;

            });
            let index_filter = filtered.indexOf(false);
            console.log(filtered)
            if (index_filter == -1) {
                const t = getLanguageTexts(this.state.selectedLanguage);
                this.setState({ show_warning: true, title_warning: t.finish_evaluation_confirm })
            }
            else {
                const t = getLanguageTexts(this.state.selectedLanguage);
                this.setState({ show_warning: true, title_warning: t.finish_pending_workbooks_confirm })
            }

        }
        this.salvar_log_warning('click_finish', 'Pop-up encerrar')
    }

    sendRequest(message) {
        if (this.props.connect == true) {
            const t = getLanguageTexts(this.state.selectedLanguage);
            this.setState({ loading_pause: true }, () => {
                this.waitResponsePause = setTimeout(() => {
                    this.setState({ loading_pause: false, show_warning_page: true, message_warning: t.pause_request_connection_error });
                }, 15000);
                this.props.socket.emit("request_pause", { reason: message, sala_id: this.props.sala.id, aluno_id: this.props.user.id, processo_id: this.props.processo.id });
            });
        }
        else {
            const t = getLanguageTexts(this.state.selectedLanguage);
            this.setState({ loading_pause: false, show_warning_page: true, message_warning: t.pause_request_connection_error });
        }
    }

    timerPause() {

        this.timer_pause_init -= 1;
        if (this.timer_pause_init <= 0) {
            document.getElementById('timer_request_init').textContent = '0 segundo(s)';
            this.timer_pause_init = 20;
            this.setState({ loading_pause_response: true });
            this.pause_status();
        }
        else {
            document.getElementById('timer_request_init').textContent = this.timer_pause_init + ' segundo(s)';
            this.timeout_pause_init = setTimeout(() => {
                this.timerPause();
            }, 1000);
        }
    }



    render() {
        let index = 0;
        const t = getLanguageTexts(this.state.selectedLanguage);
        let ultrapassou_flag = Object.values(this.props.ultrapassou_linhas).includes(true) ? true : false;
        return (
            <div className="candidate-state candidate-evaluation">
                <RequestUser show_pause_modal={this.state.show_pause_modal} sendRequest={(e) => this.sendRequest(e)} setModal={(e) => this.setState({ show_pause_modal: e })} />
                {this.state.show_pause_modal_accepted == true && <RequestAccepted
                    goToQuestion={(prova_id, questao_id, select_question) => {
                        console.log('go to question', prova_id, questao_id, select_question)
                        let prova_index = this.props.provas.map((item, id) => {
                            if (item.prova.id == prova_id) return id;
                            else return undefined
                        }).filter((item) => item != undefined)[0]
                        prova_index += this.props.questionarios.length
                        this.setState({
                            show_pause_modal_accepted: false, tab: prova_index, goTo: {
                                prova_id, questao_id, select_question
                            }
                        })
                    }}
                    show_pause_modal_accepted={this.state.show_pause_modal_accepted} sendRequest={(e) => this.pause_status()} setModal={(e) => this.setState({ show_pause_modal_accepted: e })} />}

                <video ref={this.videoRef} muted autoPlay id="background-canvas" style={{ height: '100px', position: 'absolute', top: 200, zIndex: -1 }}></video>
                {this.props.processo.simulado == false && this.props.processo_resultado?.status != 'F' && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <Chat send_message={(m) => this.props.send_message(m)} />}

                {this.state.show_pause_timer == false && <>
                    <div className="card" style={{
                        borderTopLeftRadius:0,
                        borderTopRightRadius:0,
                        borderTop:0
                    }}>
                        <div className='card-body'>

                            <div className="candidate-evaluation-intro">
                                <p className="candidate-section-kicker">{t.evaluation_in_progress}</p>
                                <h3 className="candidate-section-title">{t.evaluation_workbooks_title}</h3>
                                {this.props.processo.is_interview == false && <>
                                    <p className="candidate-evaluation-help">{t.evaluation_contains_workbooks}</p>
                                    {this.props.questionarios.map((item, id) => {
                                        return <p key={id} className="candidate-evaluation-workbook-item">- {item.questionario.name}</p>
                                    })}
                                    {this.props.provas.map((item, id) => {
                                        return <p key={id} className="candidate-evaluation-workbook-item">- {item.prova.name}</p>
                                    })}
                                    {this.props.redacoes.map((item, id) => {
                                        return <p key={id} className="candidate-evaluation-workbook-item">- {item.redacao.name}</p>
                                    })}
                                    {(this.props.questionarios.length + this.props.provas.length + this.props.redacoes.length > 1) && <>
                                        <p className="candidate-evaluation-help">{t.workbooks_separated_tabs}
                                            {this.props.processo.exam_per_time == true ? <> {t.finish_workbook_to_continue}</> : <>{this.props.redacoes.length > 0 ? t.click_tabs_questions_redaction : t.click_tabs_questions}</>}
                                        </p>
                                    </>}

                                    {this.props.questionarios.length > 0 && <p className="candidate-evaluation-help">{t.questionnaire_autosave_hint}</p>}

                                    {this.props.provas.map((item) => item.prova.type).includes('multipla_escolha') && <p className="candidate-evaluation-help">{t.multiple_choice_autosave_hint}</p>}
                                    {this.props.provas.map((item) => item.prova.type).includes('dissertativa') && <p className="candidate-evaluation-help">{t.essay_question_autosave_hint}</p>}
                                    {this.props.redacoes.length > 0 && <p className="candidate-evaluation-help">{t.redaction_autosave_hint}</p>}


                                    <p className="candidate-evaluation-help">{t.finish_all_workbooks_instruction}</p>
                                    {this.props.user.accessibility == true && this.props.user.type_supervisor != 'none' && <p className="candidate-evaluation-help is-attention"><b>{t.supervisor_attention_instruction}</b></p>}

                                </>}
                                {this.props.connect == false && this.props.socket != null && <CandidateValidationNotice tone="warning" title={t.unstable_connection}>{t.unstable_connection}</CandidateValidationNotice>}
                            </div>

                            {this.props.processo.is_interview == true && <>
                                <p className="candidate-evaluation-help">{t.oral_evaluation_call_description}</p>
                                <p className="candidate-evaluation-help">{t.interview_call_hint}</p>
                            </>}

                            {/* <FaceDetection /> */}
                            {/* <div className='timer_exam' id='timer' style={this.props.processo.type_fiscalization == 'none'?{bottom:0,right:0,top:'unset'}:{}}
                >

                </div> */}
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                                {this.props.processo.simulado == false && this.props.processo.need_pause == true && <div style={{ marginRight: 10, display: 'flex' }}>

                                    {this.state.loading_pause == false && this.props.socket != null && <button onClick={() => {
                                        if (this.props.request_user != null && this.props.request_user.approved == true && this.props.request_user.started == null) {
                                            this.setState({ show_pause_modal_accepted: true })
                                        }
                                        else {
                                            this.setState({ show_pause_modal: true });
                                        }
                                        // this.finishExam();
                                    }} type="button" id="pausa" className="btn btn-info btn-lg waves-effect waves-light"
                                    >{(this.props.request_user == null || this.props.request_user.approved == false || this.props.request_user.pause_end != null) ? t.request_pause : t.start_pause}<i className='mdi mdi-pause-circle'></i></button>}
                                    {this.state.loading_pause == true && <CandidateLoader compact title={t.pause_request_pending} description={t.wait_proctor_response} />}
                                </div>}

                                {this.state.loading_finish == false && <button onClick={() => {
                                    this.finishExam();
                                }} type="button" id="finalizar" disabled={ultrapassou_flag} className="btn btn-outline-danger btn-lg waves-effect waves-light candidate-icon-button"
                                    style={{
                                        background: ultrapassou_flag == true ? 'grey' : '',
                                        border: ultrapassou_flag == true ? '1px solid grey' : ''
                                    }}><i className='mdi mdi-check-circle-outline'></i> {t.finish_and_submit_evaluation}</button>}
                                {this.state.loading_finish == true && <CandidateLoader compact title={t.finishing_evaluation} description={t.loading_data} />}
                            </div>

                        </div>
                    </div>

                    <div className="candidate-workbook-section">
                        <p className="candidate-workbook-label">{this.props.processo.is_interview == false ? t.workbooks : t.oral_evaluation}</p>
                        <Tabs className="candidate-workbook-tabs"
                            id="controlled-tab-example"
                            activeKey={this.state.tab}
                            onSelect={(k) => {
                                console.log(k)
                                if (this.props.processo.exam_per_time == false) {
                                    this.changeTab(k);
                                }
                            }}
                        >
                            {this.props.questionarios.map((item, id) => {
                                index += 1;

                                return (
                                    <Tab tabClassName={'tab'} key={id} eventKey={index - 1} title={this.renderWorkbookTitle(item.questionario.name, 'questionario')}>
                                        {/* <p>oi</p> */}
                                        {this.props.screenExtended == false && <Questionario
                                            finishExam={() => this.finishExam()}
                                            changeTab={(k) => {
                                                this.changeTab(k);
                                            }}

                                            get_processo={() => this.props.get_processo()} indice={id} index={index - 1} />}

                                    </Tab>
                                );
                            })}
                            {this.props.provas.map((item, id) => {
                                index += 1;
                                return (
                                    <Tab tabClassName={'tab'} key={id} eventKey={index - 1} title={this.renderWorkbookTitle(item.prova.name, item.prova.type == 'dissertativa' ? 'dissertativa' : 'objetiva')}>
                                        {this.props.screenExtended == false && <Prova
                                            goTo={this.state.goTo}
                                            setPosition={(ind) => {
                                                this.selects_questions[item.prova.id] = ind;
                                            }}
                                            finishExam={() => this.finishExam()}

                                            changeTab={(k) => {
                                                this.changeTab(k);
                                            }}
                                            respostasDissertativas={this.respostas_dissertativa[item.prova.id] || {}}
                                            changeResposta={(prova_id, id, value) => {
                                                if (!this.respostas_dissertativa[prova_id]) {
                                                    this.respostas_dissertativa[prova_id] = {};
                                                }
                                                this.respostas_dissertativa[prova_id][id] = value;
                                                this.respostas[prova_id] = { questao_id: id, value, prova_id };
                                            }} get_processo={() => this.props.get_processo()} indice={id} index={index - 1} />}
                                    </Tab>
                                );

                            })}
                            {this.props.redacoes.map((item, id) => {
                                index += 1;

                                return (
                                    <Tab tabClassName={'tab'} key={id} eventKey={index - 1}
                                        title={this.renderWorkbookTitle(item.redacao.name, 'redacao')}>
                                        {/* <p>oi</p> */}
                                        {this.props.screenExtended == false && <Redacao
                                            finishExam={() => this.finishExam()}

                                            changeTab={(k) => {
                                                this.changeTab(k);
                                            }}
                                            indice={id} index={index - 1} />}

                                    </Tab>
                                );
                            })}

                            {this.props.entrevistas.map((item, id) => {
                                index += 1;

                                return (
                                    <Tab tabClassName={'tab'} key={id} eventKey={index - 1}
                                        title={this.renderWorkbookTitle(item.entrevista.name, 'entrevista')}>
                                        {/* <p>oi</p> */}
                                        {this.props.screenExtended == false && <div>
                                            <div style={{ marginTop: '1rem' }}>
                                                <h5 className="mt-0 header-title" style={{ fontSize: '1.5rem', textAlign: 'center' }}>
                                                    {item.entrevista.name}</h5>
                                                <div style={{ whiteSpace: 'pre-line' }}><b style={{ color: 'black', fontSize: 18 }}>Informação Geral:</b> <div dangerouslySetInnerHTML={{ __html: item.entrevista.descricao }}></div></div>
                                                <div style={{ marginTop: 10 }}>
                                                    {item.entrevista.topicos.map((item2, id2) => (
                                                        <div key={id2} style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}><div style={{ background: 'black', borderRadius: 100, minWidth: 6, minHeight: 6, marginRight: 5 }}></div> <span>{item2.text}</span></div>
                                                    ))}
                                                </div>
                                                <p style={{ color: 'black', textAlign: 'center', marginBottom: 10 }}><b >Data/Hora Agendada:</b> {item?.exams_oral?.datetime_initial ? moment(item.exams_oral?.datetime_initial).format('DD/MM/YYYY HH:mm') : '-'} Até {item?.exams_oral?.datetime_end ? moment(item.exams_oral?.datetime_end).format('DD/MM/YYYY HH:mm') : '-'}</p>


                                                {<div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>

                                                    {this.props.socket != null && <button onClick={() => {
                                                        this.props.changeState({ show_call: true })
                                                        // this.finishExam();
                                                    }} type="button" id="finalizar" className="btn btn-outline-info btn-lg waves-effect waves-light"
                                                    >{t.enter_call}<i className='mdi mdi-call-made'></i></button>}

                                                </div>}
                                                <hr />
                                            </div>
                                        </div>}

                                    </Tab>
                                );
                            })}


                        </Tabs>
                    </div>




                    <div className='row'>
                        <div className='col-12'>
                            <p className='back_top' style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                document.getElementById('content-page').scrollIntoView({ behavior: "smooth" })
                            }}><i className="mdi mdi-arrow-up" /> {t.back_to_top}</p>
                        </div>

                    </div>
                    <SweetAlert
                        warning
                        title={this.state.title_warning}
                        onConfirm={this.onConfirm.bind(this)}
                        onCancel={this.onCancel.bind(this)}
                        show={this.state.show_warning}
                        confirmBtnText={t.finish_confirm_button}
                        cancelBtnText={t.cancel}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        showCancel={true}
                    >
                        {t.finish_warning}
                    </SweetAlert>
                    <SweetAlert
                        warning
                        title={t.warning_title}
                        onConfirm={() => this.setState({ show_warning_page: false })}
                        show={this.state.show_warning_page}
                        confirmBtnText={t.understood}
                        confirmBtnBsStyle="danger"
                    >
                        {this.state.message_warning}
                    </SweetAlert>
                </>}
                {this.state.show_pause_timer == true &&
                    <div className="candidate-pause-state-card" style={{marginRight:0,marginLeft:0,maxWidth:'100%'}}>
                        {<>
                            <div className="candidate-pause-state-icon"><i className="mdi mdi-coffee-outline"></i></div>
                            <h4 style={{ textAlign: 'center', fontWeight: 'bold' }}>{t.pause_request_accepted}</h4>
                            <p style={{ color: 'black', marginBottom: 5, fontSize: 17, textAlign: 'center' }}>{t.pause_keep_camera}</p>
                            <p style={{ color: 'black', marginBottom: 5, fontSize: 17, textAlign: 'center' }}>{t.pause_return_before_end}</p>
                            {this.props.request_user.started != null && <p style={{ color: 'black', marginBottom: 5, fontSize: 16, textAlign: 'center' }}>{t.pause_end_hint}</p>}

                            <p className="candidate-pause-timer" style={{ textAlign: 'center', fontSize: 17 }} id="timer_request"><b>{t.granted_time}:</b> {this.convertMinute(this.props.request_user.time)}</p>
                            {this.props.request_user.started == null && <p className="candidate-pause-countdown" style={{ textAlign: 'center', fontSize: 17 }} >{t.pause_starts_in}: <span id="timer_request_init"></span></p>}

                            <div className='d-flex mt-1 justify-content-center'>
                                {this.state.loading_pause_response != true ? (this.props.request_user.started == null ? <>
                                    {/* <button onClick={() => {
                                        this.setState({ show_pause_timer: false, loading_pause: false })
                                    }} className="btn btn-secondary btn-outline btn-circle m-r-5 w-50" ><i
                                        className="mdi mdi-file"
                                        style={{ fontSize: '15px', color: 'white', fontStyle: 'normal', paddingRight: '1rem' }}>
                                            Voltar para a prova</i></button> */}
                                    {/* <button onClick={() => {
                                        this.setState({ loading_pause_response: true });
                                        this.pause_status();
                                    }} className="btn btn-success btn-outline btn-circle w-50" ><i
                                        className="mdi mdi-pause-circle"
                                        style={{ fontSize: '15px', color: 'white', fontStyle: 'normal', paddingRight: '1rem' }}>
                                            Iniciar pausa</i></button> */}
                                </> : (<button onClick={() => {
                                    this.setState({ loading_pause_response: true });
                                    this.pause_status('end');
                                }} className="btn btn-info btn-outline btn-circle w-100 mt-2 candidate-icon-button candidate-pause-end-button" ><i
                                    className="mdi mdi-play-circle"
                                    style={{ fontSize: '15px', color: 'white', fontStyle: 'normal', paddingRight: '1rem' }}>
                                        {t.end_pause}</i></button>)) : <CandidateLoader compact title={t.ending_pause} description={t.loading_data} />}


                            </div>

                        </>}

                    </div>
                }



            </div >

        );
    }

    convertMinute(value) {
        let label = '';
        if (value < 60) {
            label = '30 segundos';
        }
        else {
            label = (parseInt(value / 60) + ' minuto(s)') + (Number.isInteger(value / 60) ? '' : ' e 30 segundos');
        }
        return label;
    }

    onConfirm() {
        this.setState({ show_warning: false, loading_finish: true });
        this.finalizar_avaliacao();
    }

    onCancel() {
        this.setState({ show_warning: false });
    }




}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        faculdade: state.AppReducer.faculdade,
        stream: state.AppReducer.stream,
        stream_screen: state.AppReducer.stream_screen,

        token: state.AppReducer.token,
        provas: state.AppReducer.provas,
        redacoes: state.AppReducer.redacoes,
        questionarios: state.AppReducer.questionarios,
        mensagens: state.AppReducer.mensagens,

        socket: state.AppReducer.socket,
        user: state.AppReducer.user,
        sala: state.AppReducer.sala,
        ultrapassou_linhas: state.AppReducer.ultrapassou_linhas,
        screenExtended: state.AppReducer.screenExtended,
        request_user: state.AppReducer.request_user,
        connect: state.AppReducer.connect,
        show_call: state.AppReducer.show_call,
        entrevistas: state.AppReducer.entrevistas,
        candidate_inside_screen: state.AppReducer.candidate_inside_screen,

    }
);

export default withRouter(connect(mapsStateToProps, { logout, mudarProcesso, changeState, mudarMensagens, mergeProvasRespostas })(AvaliacaoAndamento));
